export const JOURNALS_TYPE_NAME_MAP: Record<string, string> = {
  COMPETITION: 'Competition',
  BACKTESTING: 'Backtesting',
  REAL_TRADING: 'Real Trading',
  SIMULATION: 'Simulation',
}
